import { createSessionStoredValue } from "./storage/createSessionStoredValue.ts";

export const TENANT_ID_SESSION_KEY = "sg-tenant-id";
const MIGRATE_ASSESSMENT_TENANT_ID_SESSION_KEY = "sg-migrate-assessment-tenant-id";
const SETUP_TENANT_ID_SESSION_KEY = "sg-setup-tenant-id";

export const tenantIdStorage = createSessionStoredValue(TENANT_ID_SESSION_KEY);
export const migrateAssessmentTenantIdStorage = createSessionStoredValue(MIGRATE_ASSESSMENT_TENANT_ID_SESSION_KEY);

export const setupTenantIdStorage = createSessionStoredValue(SETUP_TENANT_ID_SESSION_KEY);
